import { ref } from '@vue/composition-api'

// ip 对应国家
export const ipRegion = ref('')

export const updateIPRegion = (nation = '') => {
  ipRegion.value = nation
}

export default function useSwitchRegion() {
  return {
    ipRegion,
    updateIPRegion
  }
}
